import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Dayjs } from 'dayjs'
import { useSelector } from 'react-redux'

import { RootState } from 'store/store'
import { Holiday } from 'types/common'

const keyFormat = 'YYYY-MM-DD'

type HolidayName = string
interface HolidayState {
  holidayMap: {
    [date: string]: HolidayName
  }
}

const initialState: HolidayState = {
  holidayMap: {},
}

const holidaySlice = createSlice({
  name: 'holiday',
  initialState,
  reducers: {
    setHolidays: (
      state,
      action: PayloadAction<
        {
          dateStr: string
          name: string
        }[]
      >,
    ) => {
      console.log('---- set')
      state.holidayMap = action.payload.reduce(
        (acc, holiday) => {
          acc[holiday.dateStr] = holiday.name
          return acc
        },
        {} as HolidayState['holidayMap'],
      )
    },
  },
})

export const isHoliday = (date: Dayjs) => (state: RootState) => {
  console.log('---- date', date.format(keyFormat), state)
  return state.holiday.holidayMap[date.format(keyFormat)] !== undefined
}

export const useIsHoliday = () => {
  const holidays = useSelector((state: RootState) => state.holiday.holidayMap)
  return (date: Dayjs) => holidays[date.format(keyFormat)] !== undefined
}

export const setHolidays = (holidays: Holiday[]) => {
  return holidaySlice.actions.setHolidays(
    holidays.map((holiday) => {
      return {
        dateStr: holiday.date.format(keyFormat),
        name: holiday.name,
      }
    }),
  )
}

export default holidaySlice.reducer
